import React from 'react';
import classnames from 'classnames';

import Man from '../../../../icons/image/Man';
import Woman from '../../../../icons/image/Woman';
import { TYPES, useShowModal } from '../../../../actions/modal';
import { Circle } from '../../../../icons';
import { useStyles } from './useStyles';

const NormalColor = '#01579B';
const UnFilterColor = '#AEB8BF';
const ssrCicleColor = '#FFA600';

const getSeatIcon = (seat) => {
    if (!seat.passenger) {
        return '';
    }

    return seat.passenger.gender ? (
        <Man
            width="46"
            height="46"
            color={seat.passenger.isFiltering ? NormalColor : UnFilterColor}
            style={{
                position: 'absolute',
                width: '75px',
                height: '75px',
                top: '50%',
                left: '50%',
                marginTop: '-18px',
                marginLeft: '-23px',
            }}
        />
    ) : (
        <Woman
            width="46"
            height="46"
            color={seat.passenger.isFiltering ? NormalColor : UnFilterColor}
            style={{
                position: 'absolute',
                width: '75px',
                height: '75px',
                top: '50%',
                left: '50%',
                marginTop: '-18px',
                marginLeft: '-23px',
            }}
        />
    );
};

export const Seat = ({ seat, maxWidth, style }) => {
    const showModal = useShowModal();
    const handleClick = React.useCallback(() => {
        showModal(TYPES.PASSENGER, { data: seat });
    }, [seat]);
    const isSsr = seat.passenger && seat.passenger.ssrsList;
    const classes = useStyles(maxWidth)();

    return (
        <article key={seat.id} className={classnames('passenger-grid__seat', classes.seat)} onClick={handleClick} style={style}>
            <div className="passenger-grid__icon">
                {isSsr ? (
                    <div className="passenger-grid__ssr">
                        <Circle width="15" height="15" color={ssrCicleColor} />
                    </div>
                ) : (
                    ''
                )}
                {getSeatIcon(seat)}
            </div>
            <div className="passenger-grid__seat-name">
                <span>{`${seat.row}${seat.name}`}</span>
            </div>
        </article>
    );
};
